import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import CalendarSettings from '@/components/settings/CalendarSettings';

/**
 * Calendar Settings Page
 * 
 * Allows practitioners to connect and manage their external calendars
 * (Google Calendar, Microsoft Outlook) for availability sync.
 */
const CalendarSettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const { clinicId } = useParams<{ clinicId?: string }>();

  return (
    <div className="container mx-auto py-6 px-4 max-w-4xl">
      <div className="mb-6">
        <div className="mb-2 flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} className="h-9 w-9">
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold tracking-tight">Calendar Settings</h1>
        </div>
        <p className="text-muted-foreground">
          Manage your external calendar integrations for availability sync.
        </p>
      </div>
      
      <CalendarSettings clinicId={clinicId} />
    </div>
  );
};

export default CalendarSettingsPage;











